import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./styles/homenav.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import MainNavbar from "./components/MainNavbar";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Dashboard from "./pages/Dashboard";
// import Ledger from "./pages/Ledger";
import VehicleStock from "./pages/VehicleStock";
import SelectedVehicle from "./pages/SelectedVehicle";
import PopularVehicles from "./pages/PopularVehicles";
import ApproxDuty from "./pages/ApproxDuty";
import CustomerDashboard from "./pages/CustomerDashboard";

function AppContent() {
  const location = useLocation();

  const token = localStorage.getItem("token");

  
  const hideNavbar = location.pathname === "/login";

  return (
    <>
      {!hideNavbar && <MainNavbar />}

      <Routes>
        <Route
  path="/"
  element={token ? <Navigate to="/dashboard" /> : <Landing />}
/>

        <Route
          path="/login"
          element={token ? <Navigate to="/dashboard" /> : <Login />}
        />

        <Route path="/profile" element={<Profile />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ledger" element={<CustomerDashboard />}/>
        <Route path="/vehicle-stock" element={<VehicleStock />} />
        <Route path="/selected-vehicles" element={<SelectedVehicle />} />
        <Route path="/popular-vehicles" element={<PopularVehicles />} />
        <Route path="/approx-duty" element={<ApproxDuty />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;